export default {
  types: [
    '',
    'ADQ',
    'BB',
    'BIOSITE',
    'CGF',
    'COW',
    'CRT',
    'CW',
    'DESM',
    'GF',
    'INDOOR',
    'INST',
    'MW',
    'POSTE',
    'REF',
    'REF - RT',
    'REF - EV',
    'REF - FUND',
    'REF - EV+FUND',
    'REF - 2024',
    'RF',
    'RT',
    'SENCILLO',
    'SMALLCELL',
    'TOTEM'
  ]
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/worktypes.js